import React from "react";
import TopBanner from "../components/banner/topBanner";
import TopBox from "../components/blocks/topBox";
import { Banners, topCases, caseBlockItem } from "../components/data";
import CaseBlock from "../components/blocks/caseBlock";

export default function Cases({ tags, links }) {
  return (
    <div className="Cases">
      <TopBanner title={Banners[6].title} />
      <div className="container">
        <div className="topBlockCases">
          {topCases.map((topBoxItem) => (
            <TopBox className="topBox" topBoxItem={topBoxItem} />
          ))}
        </div>
      </div>
      <div className="casesMainBlock">
        {caseBlockItem.map((caseBlockItem) => (
          <CaseBlock
            caseBlockItem={caseBlockItem}
            tags={caseBlockItem.tag}
            links={caseBlockItem.links}
          />
        ))}
      </div>
    </div>
  );
}
